import { inject, LOCALE_ID } from "@angular/core";
import { z } from "zod";

/**
 * Initializes Zod locale based on the current LOCALE_ID.
 * This should be used as an application initializer to ensure that Zod error messages are localized correctly.
 * Currently supports Swedish (sv) locale. English is Zod's built-in default.
 */
export const zodLocaleInitializer = async () => {
  const localeId = inject(LOCALE_ID);

  // The available locales should be listed in angular.json
  // If none of the locales matches it defaults to English (Zod's built-in default)
  switch (localeId) {
    case "sv": {
      const { sv } = await import("zod/locales");
      z.config(sv());
      break;
    }
  }
};
